// extracted by mini-css-extract-plugin
export default {"didYouMeanRenderer":"didYouMeanRenderer_didYouMeanRenderer__Yhb6w"};